import * as types from './mutation-types';
import ca from "element-ui/src/locale/lang/ca";

const mutations = {
    [types.LOGIN](state, data) {
        state.token = 'Bearer ' + data.access_token;
        state.permission = JSON.stringify(data.permission);
        localStorage.setItem("jwt", 'Bearer ' + data.access_token);
        localStorage.setItem("permission", JSON.stringify(data.permission));
        localStorage.setItem("userInfo", JSON.stringify(data));
    },
    [types.LOGOUT]: (state) => {
        localStorage.clear();
        state.token = null;
        state.talgIndex = 0;
    },
    [types.TOKEN]: (state, token) => {
        state.token = token;
    },
    [types.ACTION]: (state, action) => {      // 是否可以编辑加盟商信息
        state.action = action;
    },
    [types.TAB_NAME]: (state, tab_name) => {
        state.tab_name = tab_name;
    },
    [types.USER_NAME]: (state, user_name) => {
        state.user_name = user_name;
        localStorage.setItem("user_name", state.user_name);
    },
    [types.CACHE_DATA]: (state, cache_data) => {      // 缓存筛选条件
        state.cache_data = JSON.parse(JSON.stringify(cache_data));
    },
    [types.PERMISSION]: (state, permission) => {
        state.permission = permission;
    },
    [types.TALGINDEX]: (state, talgIndex) => {
        state.talgIndex = talgIndex;
    }
};

export default mutations;



// WEBPACK FOOTER //
// ./src/store/mutations.js